"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScorePropsAgainstConfig = exports.ScoreBodyWithoutConfig = void 0;
const zod_1 = __importDefault(require("zod"));
const scores_1 = require("../../../../utils/scores");
const shared_1 = require("../shared");
const typeChecks_1 = require("../../../../utils/typeChecks");
const score_configs_1 = require("../../../../domain/score-configs");
const scores_2 = require("../../../../domain/scores");
exports.ScoreBodyWithoutConfig = (0, scores_1.applyScoreValidation)(zod_1.default.discriminatedUnion("dataType", [
    shared_1.PostScoreBodyFoundationSchema.extend(zod_1.default.object({
        value: zod_1.default.number(),
        dataType: zod_1.default.literal("NUMERIC"),
    }).shape),
    shared_1.PostScoreBodyFoundationSchema.extend(zod_1.default.object({
        value: zod_1.default.string(),
        dataType: zod_1.default.literal("CATEGORICAL"),
    }).shape),
    shared_1.PostScoreBodyFoundationSchema.extend(zod_1.default.object({
        value: zod_1.default.string(),
        dataType: zod_1.default.literal("CORRECTION"),
    }).shape),
    shared_1.PostScoreBodyFoundationSchema.extend(zod_1.default.object({
        value: zod_1.default.number().refine((val) => val === 0 || val === 1, {
            message: "Value must be either 0 or 1",
        }),
        dataType: zod_1.default.literal("BOOLEAN"),
    }).shape),
    shared_1.PostScoreBodyFoundationSchema.extend(zod_1.default.object({
        value: zod_1.default.string().min(1).max(scores_2.TEXT_SCORE_MAX_LENGTH),
        dataType: zod_1.default.literal("TEXT"),
    }).shape),
]));
const ScorePropsAgainstConfigNumeric = zod_1.default
    .object({
    value: zod_1.default.number(),
    maxValue: zod_1.default.number().optional(),
    minValue: zod_1.default.number().optional(),
    dataType: zod_1.default.literal("NUMERIC"),
})
    .superRefine((data, ctx) => {
    if ((0, typeChecks_1.isPresent)(data.maxValue) && data.value > data.maxValue) {
        ctx.addIssue({
            code: "custom",
            message: `Value exceeds maximum value of ${data.maxValue} defined in config`,
        });
    }
    if ((0, typeChecks_1.isPresent)(data.minValue) && data.value < data.minValue) {
        ctx.addIssue({
            code: "custom",
            message: `Value is below minimum value of ${data.minValue} defined in config`,
        });
    }
});
const ScorePropsAgainstConfigCategorical = zod_1.default
    .object({
    value: zod_1.default.string(),
    categories: zod_1.default.array(score_configs_1.ScoreConfigCategory),
    dataType: zod_1.default.literal("CATEGORICAL"),
})
    .superRefine((data, ctx) => {
    if (!data.categories.some(({ label }) => label === data.value)) {
        ctx.addIssue({
            code: "custom",
            message: `Value ${data.value} does not map to a valid category. Pass a valid category value.`,
        });
    }
});
exports.ScorePropsAgainstConfig = zod_1.default.union([
    ScorePropsAgainstConfigNumeric,
    ScorePropsAgainstConfigCategorical,
    zod_1.default.object({
        value: zod_1.default.number().refine((val) => val === 0 || val === 1, {
            message: "Value must be either 0 or 1",
        }),
        dataType: zod_1.default.literal("BOOLEAN"),
    }),
    zod_1.default.object({
        value: zod_1.default.string().min(1).max(scores_2.TEXT_SCORE_MAX_LENGTH),
        dataType: zod_1.default.literal("TEXT"),
    }),
]);
